import { render, staticRenderFns } from "./CompletedRequests.vue?vue&type=template&id=bb0e5112&scoped=true&"
import script from "./CompletedRequests.vue?vue&type=script&lang=js&"
export * from "./CompletedRequests.vue?vue&type=script&lang=js&"
import style0 from "./CompletedRequests.vue?vue&type=style&index=0&id=bb0e5112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0e5112",
  null
  
)

export default component.exports